import { pushCartArticle } from "../modules/cart";
import { saveArticle, saveArticleBehavior } from "shadow-client/endpoints/saleApi";
import createCartSale from "./createCartSale";

const addOfferToCart = (clubId, product, offer, productBehavior) => (dispatch, getState) => {
  return dispatch(createCartSale(clubId))
    .then(saleId => {
      return dispatch(
        saveArticle(null, {
          sale: saleId,
          productId: product.get("@id"),
          productName: product.get("name"),
          productType: product.get("type"),
          offerName: offer.get("name"),
          priceTI: offer.get("priceTI"),
          priceCurrency: offer.get("priceCurrency"),
          taxRate: offer.get("taxRate"),
          clubId: clubId
        })
      );
    })
    .then(newArticle => {
      dispatch(
        saveArticleBehavior(null, {
          article: newArticle.get("@id"),
          behaviorId: productBehavior.get("behavior"),
          configuration: productBehavior.get("configuration").toJS()
        })
      );
      dispatch(pushCartArticle(newArticle));
      return newArticle;
    });
};

export default addOfferToCart;



// WEBPACK FOOTER //
// ./src/app/redux/actions/addOfferToCart.js